<div class="flex justify-content-center">
  <div class="custom-login-card">
    <div class="w-full surface-card pt-8 px-5 sm:px-8" style="border-radius:25px">
      <div class="w-20rem login-button">
        <div class="mb-5 flex justify-content-center">
          <div class="inline-block custom-logo">
            <i class="pi pi-address-book" style="color: #9718e9; font-size: 2.5rem; "></i>
          </div>

        </div>
        <div class="grid flex flex-column align-items-center mb-5 login-header-container">
          <span class="text-500 text-2xl lg:text-3xl mb-1 transition-colors duration-300 login-title text-center">
            <span  class="text-justify" [innerHTML]="'help.contactQuestion' | translate"></span>
          </span>
          <div class="w-full sm:w-10 md:w-8 lg:w-6 mx-auto border-bottom-2 mt-3" style="color:#9718e9"></div>
          <p-button class="mt-5"
          [label]="'help.contactButton' | translate" 
          icon="pi pi-external-link"  
          (click)="goToContact()"  
          severity="help"/>
        </div>
      </div>
    </div>
  </div>
</div>